import * as d3 from 'd3'

export default {
  methods: {

    draw_Boundary(data) {

      if(this.canvasOptions) this.canvasOptions.remove()
      if(this.canvasSystems) this.canvasSystems.remove()
      
      d3.select(`#TITLE`).text(`${data.DESC} (${data.SYS})`)

      this.canvasBoundary = this.canvasForm
      .append('g')
      .attr('transform', `translate(0,0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      let overall = this.canvasBoundary
      .append('g')
      .attr('transform', `translate(40,410)`)
      .call(this.call_Page, 'OVERALL', data)

      overall
      .append('circle')
      .attr('cx', 0).attr('cy', 0).attr('r', 8).attr('fill', '#B4E3FA').attr('opacity', 0)

      overall
      .append('circle')
      .attr('id', 'BTN-OVERALL')
      .attr('cx', 0).attr('cy', 0).attr('r', 4).attr('fill', '#B4E3FA').attr('opacity', 1)
      

      let itr = this.canvasBoundary
      .append('g')
      .attr('transform', `translate(60, 410)`)
      .call(this.call_Page, 'ITR', data)

      itr
      .append('circle')
      .attr('cx', 0).attr('cy', 0).attr('r', 8).attr('fill', '#E0E0DF').attr('opacity', 0)

      itr
      .append('circle')
      .attr('id', 'BTN-ITR')
      .attr('cx', 0).attr('cy', 0).attr('r', 4).attr('fill', '#E0E0DF').attr('opacity', 1)
      

      // Forms for Overall
      this.loadSvg(
        this.canvasBoundary, {
        x   : 20,
        y   : 420,
        url : this.Boundary + `Form_Overall.svg`
      }).then(() => {
        d3.select('#FORM-OVERALL').attr('opacity', 1).attr('visibility', 'display')
        d3.selectAll('text').style('font-family', 'roboto')
        this.dashboard.filter(f=> f.type =='PRO').forEach(d=> {
          let matrix = this.gmx_matrix2(`#${d.id}`)
          d3.select(`#${d.id}`).attr('transform', null).attr('x', matrix.x).attr('y', matrix.y)
        })
        this.innerSvg_Overall(data)
      })


      // Forms for ITR Status
      this.loadSvg(
        this.canvasBoundary, {
        x   : 20,
        y   : 420,
        url : this.Boundary + `Form_ITRs_r1.svg`
      }).then(() => {
        d3.select('#FORM-ITR').attr('opacity', 0).attr('visibility', 'hidden')
        d3.selectAll('text').style('font-family', 'roboto')
        this.itrs.filter(f=> f.type =='PRO').forEach(d=> {
          let matrix = this.gmx_matrix2(`#${d.id}`)
          d3.select(`#${d.id}`).attr('transform', null).attr('x', matrix.x).attr('y', matrix.y)
        })
        this.innerSvg_ITRs(data)
      })

      // System Boundary <-----
      this.loadSvg(
        this.canvasBoundary, {
        x   : 400,
        y   : 150,
        url : this.Boundary + `svg/${data.SYS}.svg`
      }).then(() => {
        d3.selectAll('text').style('font-family', 'roboto')

        if (this.sundries2) {
            let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]

            if(this.sundries2.length > 0) {
              // [수정] 이전에 그려진 Sundries 그룹이 남아있다면 초기화
              d3.select('#SUNDRIES-GROUP').remove()
            
              // [수정] this.svg 하위에 Sundries 전용 그룹을 만들고 ID 부여
              this.sundriesGroup = this.canvasBoundary.append('g').attr('id', 'SUNDRIES-GROUP')
            
              // [수정] this.svg 대신 새로 만든 this.sundriesGroup을 전달하여 그 안에 그려지게 함
              this.gmx_Sundries(this.sundriesGroup, this.sundries2, sunData, this.JQueries.sundriesConfig.server)
            }
          }
      })

      let iconX = this.getNode(`#TITLE`) + 40
      if(iconX<330) iconX = 330
      this.gmx_btn_Navigation(
        this.canvasBoundary, 
        {type: 'home', x: iconX, y: 68, scale: 0.8,}, 
        {
          remove: [this.canvasBoundary, this.canvasBoundary],
          dur: 300, 
          timeout: 500,
          exeFunc: this.goHome,
          data: null
        }
      )

      this.draw_Donuts(this.canvasBoundary, data)
      this.chartRouter(data, 'B')
    },


    goHome() {
      

      this.draw_Handover()
      this.draw_Search()
      this.draw_SystemList()

      d3.select('#SUNDRIES-GROUP').remove()
      
      let item = this.handover.find(f => f.code == this.current.handover)
      d3.select(`#DIA_HANDOVER2`).text(item.name + `(${item.count})`)      
    },

  }
}